import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "North Cadence — Enabling People. Building Teams. Accelerating Growth.";
const DEFAULT_DESCRIPTION =
  "North Cadence is a career growth and talent services firm — resume writing, LinkedIn optimisation, interview coaching, and a full career transition programme for professionals, plus recruitment, RPO, and talent acquisition for organisations.";

export default function Seo({ title, description = DEFAULT_DESCRIPTION }) {
  const fullTitle = title ? `${title} | North Cadence` : DEFAULT_TITLE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
